import React, { useState } from "react";
import {
    Typography,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,
    Button,
    Box,
    FormLabel,
    FormHelperText,
    Divider,
    Switch,
} from "@mui/material";
import { Send, RestaurantMenu, NoMeals } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

interface LunchPollFormProps {
    onSubmit: (preference: "Veg" | "Non-Veg" | null) => void;
}


const LunchPollForm: React.FC<LunchPollFormProps> = ({ onSubmit }) => {
    const [attending, setAttending] = useState<boolean>(true);
    const [preference, setPreference] = useState<"Veg" | "Non-Veg">("Veg");
    const [error, setError] = useState<string>("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (attending && !preference) {
            setError("Please select your meal preference");
            return;
        }

        onSubmit(attending ? preference : null);
    };

    const theme = useTheme();
    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Box sx={{
                width: "100%",
                mb: 2,
                borderRadius: 2,
                background: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                py: 2,
                px: 3,
                display: "flex",
                alignItems: "center",
            }}>
                <RestaurantMenu sx={{ mr: 2, color: theme.palette.primary.contrastText }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Today's Lunch Poll
                </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Typography>Not Attending</Typography>
                <Switch
                    checked={attending}
                    onChange={(e) => setAttending(e.target.checked)}
                    color="primary"
                    sx={{ mx: 1 }}
                />
                <Typography>Attending</Typography>
            </Box>

            {attending && (
                <>
                    <Divider sx={{ my: 2 }} />

                    <FormControl component="fieldset" sx={{ mb: 3 }} error={!!error}>
                        <FormLabel component="legend">Meal Preference</FormLabel>
                        <RadioGroup
                            value={preference}
                            onChange={(e) => {
                                setPreference(e.target.value as "Veg" | "Non-Veg");
                                setError("");
                            }}
                        >
                            <FormControlLabel
                                value="Veg"
                                control={<Radio color="secondary" />}
                                label={
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <RestaurantMenu color="secondary" sx={{ mr: 1 }} />
                                        <Typography>Vegetarian</Typography>
                                    </Box>
                                }
                            />
                            <FormControlLabel
                                value="Non-Veg"
                                control={<Radio />}
                                label={
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <NoMeals color="primary" sx={{ mr: 1 }} />
                                        <Typography>Non-Vegetarian</Typography>
                                    </Box>
                                }
                            />
                        </RadioGroup>
                        {error && <FormHelperText>{error}</FormHelperText>}
                    </FormControl>
                </>
            )}

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<Send />}
                size="large"
            >
                Submit Response
            </Button>
        </Box>
    );
};

export default LunchPollForm;